// ordering level reducer
import { get, union } from 'lodash';
import {
  CLEAR_SELECTED_TABLE,
  CLEAR_UPDATED_SCAN_CODE,
  DISABLED_MENU_ITEMS,
  DISPATCH_CUSTOMIZATION_LOADER,
  DISPATCH_RESTAURANT_GROUP,
  DISPATCH_SELECTED_ADDRESS,
  FETCH_AVAILABLE_OFFERS,
  FETCH_GUEST_ORDERS,
  FETCH_MENU_ITEM_CUSTOMIZATIONS,
  FETCH_ORDERED_ITEMS,
  FETCH_ORDER_STATUS,
  FETCH_RESTAURANT_DATA,
  FETCH_RESTAURANT_MENU,
  FETCH_SELECTED_TABLE,
  FETCH_VIEW_CART,
  PLACE_ORDER,
  PREVIOUS_SELECTED_TABLE,
  UPDATE_MENU,
  FETCH_RECENTLY_VISITED_RESTAURANT,
  FETCH_GUEST_PREVIOUS_ORDERED_ITEMS,
  CLEAR_GUEST_PREVIOUS_ORDERED_ITEMS,
  FETCH_GUEST_ORDER_COUNT,
  FETCH_MENU_ITEM_VARIATIONS,
  CLEAR_SELECTED_ADDRESS,
  UPDATE_GUEST_ADDRESSES,
  ADD_GUEST_ADDRESS,
  DELETE_GUEST_ADDRESS,
  DISPATCH_UPDATED_GUEST_ADDRESSES,
  FETCH_GUEST_TABLE_RESERVATIONS,
  DISPATCH_REWARD_DEALS,
  DISPATCH_DEAL_OFFER_DATA,
  DISPATCH_DRAFT_SELECTED_ADDRESS,
  FETCH_CART_UPSELL_SUGGESTIONS,
  FETCH_CART_UPSELL_SUGGESTIONS_ERROR,
  CLEAR_CART_UPSELL_SUGGESTIONS,
  } from '../../actions/ordering/actionType';
import { GET_ORDER_FEEDBACK_RESPONSE } from '../../actions/actionType';
import { mergeCartUpsellSuggestions } from '../../containers/Ordering/helpers/cartUpsellSuggestionsStorage';

const ordering = (state = {}, action = {}) => {
  if (action.type === FETCH_RESTAURANT_MENU) {
    const {
      restaurant,
      selectedTable,
      serviceTypes,
      sections,
      disabledCategories,
      recommendedSections,
      menuTags,
      tagBasedCategories,
    } = action;
    return {
      ...state,
      menu: union(recommendedSections, sections),
      restaurant,
      selectedTable,
      serviceTypes,
      disabledCategories,
      recommendedSections,
      menuTags: menuTags || [],
      tagBasedCategories: tagBasedCategories || [],
    };
  } else if (action.type === DISPATCH_RESTAURANT_GROUP) {
    const { restaurantGroup } = action;
    return {
      ...state,
      restaurantGroup,
    };
  } else if (action.type === FETCH_RESTAURANT_DATA) {
    const { restaurant } = action;
    return {
      ...state,
      restaurant,
    };
  } else if (action.type === UPDATE_MENU) {
    const { menu } = action;
    return {
      ...state,
      searchResult: menu,
    };
  } else if (action.type === FETCH_MENU_ITEM_CUSTOMIZATIONS) {
    const { customization } = action;
    return {
      ...state,
      customization,
    };
  } else if (action.type === FETCH_VIEW_CART) {
    const { items } = action;
    return {
      ...state,
      viewCart: items,
    };
  } else if (action.type === PLACE_ORDER) {
    const { orderedItems } = action;
    return {
      ...state,
      orderedItems,
    };
  } else if (action.type === FETCH_ORDER_STATUS) {
    let orderedItems = get(state, 'orderedItems', {});
    const { orderStatus } = action;
    orderedItems.statusCode = get(orderStatus, 'status', '');
    return {
      ...state,
      orderedItems,
    };
  } else if (action.type === FETCH_ORDERED_ITEMS) {
    const { orderedItems } = action;
    return {
      ...state,
      orderedItems,
    };
  } else if (action.type === ADD_GUEST_ADDRESS) {
    const { addressObjBody } = action;
    return {
      ...state,
      guestAddresses: Array.isArray(state.guestAddresses)
        ? [...state.guestAddresses, addressObjBody]
        : [addressObjBody],
    };
  } else if (action.type === DELETE_GUEST_ADDRESS) {
    const { guestAddressBodyid } = action;
    const updatedGuestAddresses = state.guestAddresses.filter(
      (address) => address.id !== guestAddressBodyid,
    );
    return {
      ...state,
      guestAddresses: updatedGuestAddresses,
      selectedAddress: {},
    };
  } else if (action.type === UPDATE_GUEST_ADDRESSES) {
    const { guestAddresses } = action;
    return {
      ...state,
      guestAddresses,
    };
  } else if (action.type === DISPATCH_UPDATED_GUEST_ADDRESSES) {
    const { guestAddress } = action;
    const updatedGuestAddresses = state.guestAddresses.map((address) => {
      if (address.id === guestAddress.id) {
        return guestAddress;
      }
      return address;
    });
    return {
      ...state,
      guestAddresses: updatedGuestAddresses,
      selectedAddress: {},
    };
  } else if (action.type === CLEAR_SELECTED_TABLE) {
    const { selectedTable } = action;
    return {
      ...state,
      selectedTable,
    };
  } else if (action.type === CLEAR_SELECTED_ADDRESS) {
    return {
      ...state,
      selectedAddress: {},
      draftSelectedAddress: {},
    };
  } else if (action.type === CLEAR_UPDATED_SCAN_CODE) {
    const { updatedScanCode } = action;
    return {
      ...state,
      updatedScanCode,
    };
  } else if (action.type === FETCH_GUEST_ORDERS) {
    const { guestOrders } = action;
    return {
      ...state,
      guestOrders,
    };
  } else if (action.type === DISABLED_MENU_ITEMS) {
    const { disabledItems } = action;
    return {
      ...state,
      disabledItems,
    };
  } else if (action.type === FETCH_SELECTED_TABLE) {
    const { selectedTable } = action;
    return {
      ...state,
      selectedTable,
    };
  } else if (action.type === PREVIOUS_SELECTED_TABLE) {
    const { previousSelectedTable } = action;
    return {
      ...state,
      previousSelectedTable,
    };
  } else if (action.type === DISPATCH_SELECTED_ADDRESS) {
    const { selectedAddress } = action;
    return {
      ...state,
      selectedAddress,
    };
  } else if (action.type === DISPATCH_DRAFT_SELECTED_ADDRESS) {
    const { draftSelectedAddress } = action;
    return {
      ...state,
      draftSelectedAddress,
    };
  } else if (action.type === DISPATCH_CUSTOMIZATION_LOADER) {
    const { showCustomizationLoader } = action;
    return {
      ...state,
      showCustomizationLoader,
    };
  } else if (action.type === FETCH_AVAILABLE_OFFERS) {
    const { availableOffers } = action;
    return {
      ...state,
      availableOffers,
    };
  } else if (action.type === FETCH_RECENTLY_VISITED_RESTAURANT) {
    const { recentlyVisitedOutlets } = action;
    return { ...state, recentlyVisitedOutlets };
  } else if (action.type === FETCH_GUEST_PREVIOUS_ORDERED_ITEMS) {
    const { guestPreviousOrderedItems } = action;
    return { ...state, guestPreviousOrderedItems };
  } else if (action.type === CLEAR_GUEST_PREVIOUS_ORDERED_ITEMS) {
    return {
      ...state,
      guestPreviousOrderedItems: [],
    };
  } else if (action.type === FETCH_GUEST_ORDER_COUNT) {
    const { orderCount } = action;
    return { ...state, orderCount };
  } else if (action.type === FETCH_MENU_ITEM_VARIATIONS) {
    const { variations } = action;
    return {
      ...state,
      variations,
    };
  } else if (action.type === GET_ORDER_FEEDBACK_RESPONSE) {
    const { orderFeedbackResponse } = action;
    return {
      ...state,
      orderFeedbackResponse,
    };
  } else if (action.type === FETCH_GUEST_TABLE_RESERVATIONS) {
    const { guestTableReservations } = action;
    return { ...state, guestTableReservations };
  } else if (action.type === DISPATCH_REWARD_DEALS) {
    const { rewardDeals } = action;
    return { ...state, rewardDeals };
  } else if (action.type === DISPATCH_DEAL_OFFER_DATA) {
    const { dealOffer } = action;
    return { ...state, dealOffer };
  } else if (action.type === FETCH_CART_UPSELL_SUGGESTIONS) {
    const { suggestions, limit, isLoading, error, cachedSuggestions, cachedLimit } = action;
    const prev = get(state, 'cartUpsellSuggestions', {});
    const prevCached = get(prev, 'cachedSuggestions', []);
    const nextSuggestions =
      suggestions !== undefined ? suggestions : get(prev, 'suggestions', []);
    const nextLimit = limit !== undefined ? limit : get(prev, 'limit', 0);
    const nextCachedSuggestions =
      cachedSuggestions !== undefined
        ? cachedSuggestions
        : suggestions !== undefined && Array.isArray(suggestions)
          ? mergeCartUpsellSuggestions(suggestions, prevCached)
          : prevCached;
    const nextCachedLimit =
      cachedLimit !== undefined
        ? cachedLimit
        : limit !== undefined && limit > 0
          ? limit
          : get(prev, 'cachedLimit', 0);

    return {
      ...state,
      cartUpsellSuggestions: {
        suggestions: nextSuggestions,
        limit: nextLimit,
        isLoading: isLoading !== undefined ? isLoading : get(prev, 'isLoading', false),
        error: error !== undefined ? error : get(prev, 'error', null),
        cachedSuggestions: nextCachedSuggestions,
        cachedLimit: nextCachedLimit,
      },
    };
  } else if (action.type === FETCH_CART_UPSELL_SUGGESTIONS_ERROR) {
    const { error, isLoading } = action;
    const prev = get(state, 'cartUpsellSuggestions', {});
    return {
      ...state,
      cartUpsellSuggestions: {
        ...prev,
        isLoading: isLoading !== undefined ? isLoading : false,
        error: error || null,
      },
    };
  } else if (action.type === CLEAR_CART_UPSELL_SUGGESTIONS) {
    return {
      ...state,
      cartUpsellSuggestions: {
        suggestions: [],
        limit: 0,
        isLoading: false,
        error: null,
        cachedSuggestions: [],
        cachedLimit: 0,
      },
    };
  }
  return state;
};

export default ordering;
